var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewCartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00014 13.5H17.1359C18.1487 13.5 18.6551 13.5 19.0582 13.3112C19.4134 13.1448 19.7118 12.8777 19.9163 12.5432C20.1485 12.1633 20.2044 11.66 20.3163 10.6534L20.9013 5.38835C20.9355 5.08088 20.9525 4.92715 20.9031 4.80816C20.8597 4.70366 20.7821 4.61697 20.683 4.56228C20.5702 4.5 20.4155 4.5 20.1062 4.5H3.50014M1 1.5H2.24844C2.51306 1.5 2.64537 1.5 2.74889 1.55032C2.84002 1.59463 2.91554 1.66557 2.96544 1.75376C3.02212 1.85394 3.03037 1.98599 3.04688 2.2501L3.95312 16.7499C3.96963 17.014 3.97788 17.1461 4.03456 17.2462C4.08446 17.3344 4.15998 17.4054 4.25111 17.4497C4.35463 17.5 4.48694 17.5 4.75156 17.5H18M6.5 21H6.51M15.5 21H15.51M7 21C7 21.2761 6.77614 21.5 6.5 21.5C6.22386 21.5 6 21.2761 6 21C6 20.7239 6.22386 20.5 6.5 20.5C6.77614 20.5 7 20.7239 7 21ZM16 21C16 21.2761 15.7761 21.5 15.5 21.5C15.2239 21.5 15 21.2761 15 21C15 20.7239 15.2239 20.5 15.5 20.5C15.7761 20.5 16 20.7239 16 21Z",
    stroke: "#F9F6F0",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCartIcon);
export default __webpack_public_path__ + "static/media/new-cart-icon.7c856867fe1115837795be8e4c07ef3a.svg";
export { ForwardRef as ReactComponent };